import { ChangeEvent, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../App";
import { findPlaceByGroupID, findDefaultValueGroupID } from "../Home/Home";
// import placeDetails from "../../data/placeData.json";

interface Place {
  setPlace?: ({ id, groupId, lat, long }: {
    id: number,
    groupId: number,
    lat: number,
    long: number; }) => void;
  places: Array<{ groupId: number, name: string, coordinates: Array<number> }>
  groupID:any
}
const Navbar = ({ places,groupID, setPlace }: Place) => {
  const [status, setStatus] = useContext<any>(UserContext);
  // const [status] = useContext<any>(UserContext);
  const led = status?.status === "OK" ? "led-green" : "led-red";

  // useEffect(() => {
  //   fetch("https://lit-forest-88750.herokuapp.com/")
  //     .then((res) => res.json())
  //     .then((data) => setStatus(data))
  //     .catch((err)=>console.log(err))
  // }, []);

  const handleChange = (e:ChangeEvent<HTMLSelectElement>) => {
    e.preventDefault();
    const value = e.target.value as any;
    // const name = e.target[value].innerText.toLowerCase();
    setPlace?.({
      id: value,
      groupId: places[value].groupId,
      lat: places[value].coordinates[0],
      long: places[value].coordinates[1]
      // name: name,
    });
  };

  return (
    <nav className="nav-container">
      <div className="navigation">
        <ul className="navigation-items">
          <li className="select">
            <select
              data-testid="selection"
              name="sensors"
              id="sensor"
              defaultValue={findDefaultValueGroupID(groupID,places)}
              onChange={(e) => handleChange(e)}
            >
              {places.map( (place:any, index:any) => (
                  <option key={index} value={index}>{place.name}</option>
              ))}
            </select>
          </li>
          <li>
             ...
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
